import React from 'react';
import { EmptyMessageTemplate } from 'themes/components';

function EmptyMessage(props) {
    return <EmptyMessageTemplate {...props} />
}

export default EmptyMessage;